import { INotification, IReminderSetting } from './../../types/notificationTypes';
import { 
  ICorrectUri, IDataUserEmail, userEmail, IUserTimeZoneDto, 
  IProfileInfoDto, IVersion, ITimeZone, IEditCalendar, INewCalendar  
} from '@utils';
import { AxiosResponse } from 'axios';
import { Service } from 'typedi';
import { axios } from '../axios';
import { ShowNotification } from '../ShowNotification';
import { IColor } from '../../types/colors';
import { ISynchronizationDto } from '../../types';

@Service()
export class ProfileRequest {

  @ShowNotification()
  getSyncStatus(): Promise<AxiosResponse<ISynchronizationDto>> {
    return axios
      .get('/integration/sync/status');
  }

  @ShowNotification() 
  synchronize() {
    return axios
      .get('/integration/synchronize');
  }

  @ShowNotification()
  connectingNewCalendarUrl(url: INewCalendar): Promise<AxiosResponse<ICorrectUri>> {
    return axios
      .post('/integration/ical', url);
  }

  @ShowNotification()
  editCalendar(newCalendar: IEditCalendar) {
    return axios
      .put('/integration/ical', newCalendar);
  }

  @ShowNotification()
  deleteCalendarUrl(id: number) {
    return axios.delete(`/integration/ical?id=${id}`);
  }

  @ShowNotification()
  getEmails(): Promise<AxiosResponse<IDataUserEmail>> {
    return axios
      .get(`${userEmail}all`);
  }

  @ShowNotification()
  resendEmail(email: string): Promise<AxiosResponse<string>> {
    return axios
      .post('user/email/resend', email);
  }

  @ShowNotification('Почта добавлена!', 'success')
  setNewEmail(email: string) {
    return axios
      .post(`${userEmail}`, { email });
  }

  @ShowNotification('Почта удалена', 'warning')
  deleteEmail(email: string) {
    return axios
      .delete(`${userEmail}`, { data: email });
  }

  @ShowNotification() 
  getTimeZonesList(): Promise<AxiosResponse<ITimeZone[]>> {
    return axios
      .get('picklist/timezones');
  }

  @ShowNotification()
  setTimeZone(timezone: IUserTimeZoneDto) {
    return axios
      .put(`user/timezone`,  timezone);
  }

  @ShowNotification()
  getUserInformation(): Promise<AxiosResponse<IProfileInfoDto>> {
    return axios
      .get('user/info');
  }

  @ShowNotification()
  getNotifications(): Promise<AxiosResponse<INotification[]>> {
    return axios
      .get('reminder/all');
  }

  @ShowNotification()
  addNotification(notification: INotification) {
    return axios
      .post('reminder/add', notification);
  }

  @ShowNotification()
  editNotification(notification: INotification) {
    return axios
      .put('reminder/edit', notification);
  }

  @ShowNotification()
  deleteNotification(minutes: number) {
    return axios
      .delete(`reminder/remove/?minutes=${minutes}`);
  }

  @ShowNotification() 
  updateReminderSettings(minutes: number) {
    return axios  
      .post('reminder/switch', { minutes })
  }

  @ShowNotification()
  getReminderSetting(): Promise<AxiosResponse<number>> {
    return axios
      .get('reminder/offPeriod');
  }

  @ShowNotification()
  getVersion(): Promise<AxiosResponse<IVersion>> {
    return axios
      .get('version/current');
  }

  @ShowNotification()
  getColors(): Promise<AxiosResponse<IColor[]>> {
    return axios 
      .get('picklist/calendar-colors');
  }
}
